
 
import Webmessage from "./web_root/message";
import Webhistory from "./web_root/history";
import Webtools from "./web_root/tools";
import Websearch from "./web_root/search";
import Settings from "./profile_roots/settings";
import Home from "./home_pages/home";
import Shorturl from "./design_root/short-url";
import Projects from "./design_root/projects";
import Order from "./products_root/order";
export const WebRoutes = [
 { path: '/', name: 'Web Home', element: <Home/> },
 { path: '/short-url', name: 'Web Home', element: <Shorturl/> },
 { path: '/projects', name: 'Web Home', element: <Projects/> },
 { path: '/order', name: 'Web Home', element: <Order/> },
 { path: '/message', name: 'Message', element: <Webmessage /> },
 { path: '/history', name: 'History', element: <Webhistory /> },
 { path: '/tools', name: 'Tools', element: <Webtools /> },
 { path: '/search', name: 'Tools', element: <Websearch /> },
 { path: '/settings', name: 'Tools', element: <Settings/> },
]